"use client";

import { Link } from "@/i18n/navigation";
import { FiCalendar, FiMessageCircle, FiPhone } from "react-icons/fi";

export default function MobileActionBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-fbtt-navy/10 bg-white/95 shadow-[0_-4px_20px_rgba(13,34,64,0.08)] backdrop-blur-md lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3">
        <Link
          href="/transfers/request"
          className="flex flex-col items-center justify-center gap-1 py-3 text-fbtt-navy transition-colors active:bg-fbtt-orange/10"
        >
          <FiCalendar className="h-5 w-5 text-fbtt-orange" />
          <span className="text-[11px] font-bold uppercase tracking-wide">Book</span>
        </Link>
        <a
          href="https://wa.me/59995146060?text=Hi!%20I%27d%20like%20to%20book%20a%20transfer."
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 border-x border-fbtt-navy/10 py-3 text-fbtt-navy transition-colors active:bg-[#25D366]/10"
        >
          <FiMessageCircle className="h-5 w-5 text-[#25D366]" />
          <span className="text-[11px] font-bold uppercase tracking-wide">WhatsApp</span>
        </a>
        <a
          href="tel:+59998699559"
          className="flex flex-col items-center justify-center gap-1 py-3 text-fbtt-navy transition-colors active:bg-fbtt-teal/10"
        >
          <FiPhone className="h-5 w-5 text-fbtt-teal" />
          <span className="text-[11px] font-bold uppercase tracking-wide">Call</span>
        </a>
      </div>
    </div>
  );
}
